// extracted by mini-css-extract-plugin
export default {"french":"#5390d9","grey":"color-mix(in srgb, light-dark(#999999, #faf9f6), light-dark(#ffffff, #000839) 20%)","toggleWrapper":"Toggle_toggleWrapper__YzI0p"};